import type {Context} from '../types';

/**
 *
 * This Patch removes href attribute and link from RTE node data
 *
 */

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data, type} = jsonNode;

  const isRTE = type === 'RichText';
  const hasHrefAttr = data && data.attr && data.attr.href;
  const hasLink = data && data.link;

  const patchNeeded = isRTE && (hasHrefAttr || hasLink);

  return {
    needed: patchNeeded,
    logData: {
      msg: 'RTE with href attribute and/or link',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (hasHrefAttr) {
        // eslint-disable-next-line webflow/no-delete
        delete data.attr.href;
        if (Object.keys(data.attr).length === 0) {
          // eslint-disable-next-line webflow/no-delete
          delete data.attr;
        }
      }

      if (hasLink) {
        // eslint-disable-next-line webflow/no-delete
        delete data.link;
      }
    },
  };
};
